import React from 'react';
import './Films.css';
import Submenu from '../../components/Submenu';
import { FilmItem } from '../../components/ContentItems';
import { useContent } from '../../context/ContentContext';

const Films = () => {
  const { films } = useContent();
  const sortedFilms = [...films].sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <>
      <div className="multimedia">
        <Submenu />
        <br />
        <br />
        <div className="film-grid">
          {sortedFilms.map((film) => (
            <FilmItem
              key={film.id || `film-${film.sortOrder}-${film.title}`}
              film={film}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Films;
